import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const configuracion = {
  namespaced: true,
  state: {
    mostrarMainMenu: false,
    snackResponse: {
      mostrar: false,
      texto: '',
      color: '',
    },
    isCargando: false,
  },
  actions,
  mutations,
  getters,
};

export default configuracion;
